import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1302"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.378 1.947 7.677 3.769l.059 4.446 1.128.179-3.916 6.617H16zm-1.629.229a.744.744 0 1 0-1.207-.87.744.744 0 0 0 1.207.87zm-2.794 8.063a.744.744 0 1 0-1.207-.87.744.744 0 0 0 1.207.87zm.901-6.323a1.037 1.037 0 1 0-1.681-1.213 1.037 1.037 0 0 0 1.681 1.213zm-.69 3.535a1.417 1.417 0 1 0-2.299-1.659 1.417 1.417 0 0 0 2.299 1.659zm-2.211 3.487a1.87 1.87 0 1 0-2.19 3.033 1.87 1.87 0 0 0 2.19-3.033z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }